<div class="container">
  <div class="row" style="margin-top: 10px;" *ngIf="!isTest">
    <div class="col-4">
      <mat-card class="quote" style="cursor: pointer;" routerLink="/listen-einlesen">
        <mat-card-content>
          Angebote einlesen
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-4">
      <mat-card class="customer" style="cursor: pointer;" routerLink="/kundenverwaltung">
        <mat-card-content>
          Kundendaten
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-4">
      <mat-card class="partner" style="cursor: pointer;" routerLink="/industriepartner" *ngIf="user && user.role == 'ROLE_ADMIN'">
        <mat-card-content>
          Industriepartner
        </mat-card-content>
      </mat-card>
      <mat-card class="partner" style="cursor: pointer;" [routerLink]="'/industriepartner/'+user.anbieterNummer" *ngIf="user && user.role == 'ROLE_INDUSTRIEPARTNER'">
        <mat-card-content>
          Industriepartner
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row" style="margin-top: 10px;" *ngIf="!isTest">
    <div class="col-4">
      <mat-card class="quote" style="cursor: pointer;" routerLink="/listen-zuweisen">
        <mat-card-content>
          Angebote zuweisen
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-4">
      <mat-card class="customer" style="cursor: pointer;" routerLink="/vorgabewerte">
        <mat-card-content>
          Vorgabewerte 
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-4">
      <mat-card class="partner" style="cursor: pointer;" routerLink="/admin" *ngIf="user && user.role == 'ROLE_ADMIN'">
        <mat-card-content>
          Administration
        </mat-card-content>
      </mat-card>
    </div> 
  </div>
  <div class="row" style="margin-top: 10px;" *ngIf="!isTest">
    <div class="col-4">
      <mat-card class="quote" style="cursor: pointer;" routerLink="/reporting">
        <mat-card-content>
          Reporting
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-4">
      <a style="cursor: pointer; background: #FFFFCF; text-align: center;
        display: block; padding: 20px; border-radius: 5px; color: black;" href="http://www.digibest.eu:8181"
        target="_blank"
        *ngIf="isDemo && user.role == 'ROLE_ADMIN'">
        CRM
      </a>
    </div>
    <div class="col-4" *ngIf="!isTest">
      <mat-card class="partner" style="cursor: pointer;" routerLink="/profil">
        <mat-card-content>
          Eigene Daten
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row" style="margin-top: 10px;" *ngIf="!isTest">
    <div class="col-4">
  
    </div>
    <div class="col-4">
      <a style="cursor: pointer;background: #FFFFCF; text-align: center;
      display: block; padding: 20px; border-radius: 5px; color: black;" href="https://digibest.eu/digibest-dev"
      target="_blank"
      *ngIf="!isDemo && user.role == 'ROLE_ADMIN'">
      Zum Demosystem
    </a>
    <a style="cursor: pointer; background: #FFFFCF; text-align: center;
      display: block; padding: 20px; border-radius: 5px; color: black;" href="https://digibest.eu/angebotsverwaltung"
      target="_blank"
              *ngIf="isDemo && user.role == 'ROLE_ADMIN'">
        Zum Produktivsystem
    </a>
    </div>
    <div class="col-4">
      
    </div>
  </div>
  <div class="row" style="margin-top: 10px;">
    <div class="col-4">
  
    </div>
    <div class="col-4">
  
    </div>
    <div class="col-4">
      
    </div>
  </div>
  <div class="row" style="margin-top: 10px;">
    <div class="col-4">
  
    </div>
    <div class="col-4">
  
    </div>
    <div class="col-4">
    </div>
  </div>
  <div class="row" style="margin-top: 10px;">
    <div class="col-4">
  
    </div>
    <div class="col-4">
  
    </div>
    <div class="col-4">
      
    </div>
  </div>
  <div class="row" style="margin-top: 10px;" *ngIf="!isTest">
    <div class="col-4">
  
    </div>
    <div class="col-4">
  
    </div>
    <div class="col-4">
      <div [hidden]="!user || user.role != 'ROLE_APOTHEKE'" style="margin-left: 10px; margin-right: 10px;">
        <mat-card style="cursor: pointer;" routerLink="/profil">
          <mat-card-content>
            Eigene Daten
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
